module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    staticStyle: {
      "text-align": "left",
      "font-size": "2.3em"
    },
    attrs: {
      "id": "pz3-1"
    }
  }, [_vm._v("\n\t\t\t\t\tContents ")]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz3-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/whyruleofthumb#b1",
      "id": "a1"
    }
  }, [_c('b', [_vm._v("Why Rule of Thumb?")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz3-4"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/chapter01#b2",
      "id": "a2"
    }
  }, [_vm._v("Chapter 1:")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz3-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#b3",
      "id": "a3"
    }
  }, [_vm._v("Sustaining a Small Business:")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#b3"
    }
  }, [_vm._v("Getting Started What is Business Sustainability? ")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz3-7"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter02#b5",
      "id": "a5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2:")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "A0x"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#b6",
      "id": "a6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sustaining a Small Business: Diversifying Revenues")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#b7a",
      "id": "a7a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Can I Diversify Business Revenues?\n\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz3-11"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter03#b8",
      "id": "a8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3:")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz3-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#b9",
      "id": "a9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sustaining a Small Business:")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#b10a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Social Media Marketing")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#b10a",
      "id": "a10a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What is Social Media Marketing? ")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz3-15"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter04#b11",
      "id": "a11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4:")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz3-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#b12",
      "id": "a12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sustaining a Small Business: Branding ")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#b12a",
      "id": "a12a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Can I Brand My Small Business? ")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz3-20"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter05#b13",
      "id": "a13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5:")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz3-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#b14",
      "id": "a14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sustaining a Small Business: Networking ")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#b14a",
      "id": "a14a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Can I Use Networking to Increase Revenues?\n\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz3-23"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter06#b15",
      "id": "a15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6:")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz3-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#b16",
      "id": "a16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sustaining a Small Business:")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#b17a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contract Bidding Opportunities ")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#b17a",
      "id": "a17a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Can I Use Contract Bidding to Increase Revenues?\n\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz3-28"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter07#b18",
      "id": "a18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7:")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz3-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#b19",
      "id": "a19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sustaining a Small Business: Finances ")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#b20",
      "id": "a20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Can I Find Money for My Business?")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz4-1"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter08#b20a",
      "id": "a20a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8:")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz4-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#b21",
      "id": "a21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sustaining a Small Business: Reinvention ")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#b21a",
      "id": "a21a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Can I Meet Emerging Service or Product\n\t\t\t\t\tDemands?")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz4-5"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter09#b22",
      "id": "a22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9:")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz4-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#b23",
      "id": "a23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sustaining a Small Business: Succession ")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#b30",
      "id": "a30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Can I Plan for Succession? ")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz4-8"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Conquering#b24",
      "id": "a24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conquering The Basics")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz4-9"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Additional#b25",
      "id": "a25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz4-10"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/abouttheauthors#b26",
      "id": "a26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author Biography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 63
// module chunks = 0